import React, { useEffect } from "react";
import useState from "react-usestateref";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import * as Icons from "@material-ui/icons";
import {
  useUserDispatch,
  saveBlog,
  updateBlog,
  deleteBlog,
} from "../context/BlogContext";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
// import { PdfImage } from '../images/PDF_file_icon.svg.png'
import PdfImage from "../images/PDF_file_icon.svg.png";
// import Pagination from "react-js-pagination";
import Pagination from "@material-ui/lab/Pagination";
import Skeleton from "react-skeleton-loader";
import useStyles from "../components/Header/styles";
import moment from "moment";
import SearchBar from "./searchbar";
// components
import PageTitle from "../components/PageTitle";
// import Widget from "../../components/Widget";
// import Table from "../dashboard/components/Table/Table";
// data
// import mock from "../dashboard/mock";
const styles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  p: 4,
};

const SPACED_DATE_FORMAT = "yyyy-MM-DD HH:mm:ss.SSS";

const datatableData = [
  [
    "Joe James",
    "Example Inc.",
    <Icons.Edit className="cursor-pointer" />,
    <Icons.Delete className="cursor-pointer" />,
  ],
  [
    "Joe James",
    "Example Inc.",
    <Icons.Edit className="cursor-pointer" />,
    <Icons.Delete className="cursor-pointer" />,
  ],
  [
    "Joe James",
    "Example Inc.",
    <Icons.Edit className="cursor-pointer" />,
    <Icons.Delete className="cursor-pointer" />,
  ],
  [
    "Joe James",
    "Example Inc.",
    <Icons.Edit className="cursor-pointer" />,
    <Icons.Delete className="cursor-pointer" />,
  ],
  [
    "Joe James",
    "Example Inc.",
    <Icons.Edit className="cursor-pointer" />,
    <Icons.Delete className="cursor-pointer" />,
  ],
];

const columns = [
  {
    name: "categoryname",
    label: "Category Name",
    options: {
      filter: true,
      sort: true,
    },
  },
  // {
  //  name: "categoryurl",
  //  label: "Category URL",
  //  options: {
  //   filter: true,
  //   sort: false,
  //  }
  // },
  {
    name: "updatedAt",
    label: "Time",
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) =>
        moment(new Date(value)).format(SPACED_DATE_FORMAT),
    },
  },
];

const style = {
  background: "#rgb(83 109 251)",
};

export default function Tables(props) {
  var [categoryNameValue, setcatagoryNameValue, categoryNameValueref] =
    useState("");
  var [categorySlug, setcategorySlug, categorySlugref] = useState("");
  var classes = useStyles();

  var [categoryStatusValue, setcategoryStausValue, categoryStatusValueref] =
    useState(1);
  var [categoryblogSite, setcategoryblogSite, setcategoryblogSiteref] =
    useState("Choose Site");
  console.log(categoryblogSite);
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [categoryNameList, setcategoryNameList, categoryNameListref] = useState(
    [],
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalpages] = useState(0);
  const [pageactive, setActivePage, pageactiveref] = useState("add");
  const [categorydata, setCategory, categorydataref] = useState("");
  const [BlocksentelscurrentPage, setBlocksentelscurrentPage] = useState(1);
  const [BlocksentelstotalPage, setBlocksentelstotalPage] = useState(0);
  var [
    BlocksentelscategoryNameList,
    setBlocksentelscategoryNameList,
    BlocksentelscategoryNameListref,
  ] = useState([]);
  const [formstatus, setFormstatus] = useState(false);
  const [pageLoader, setpageLoader] = useState(true);
  const [blockpageLoader, setblockpageLoader] = useState(true);

  const recordPerPage = 5;
  // total number of the "records"
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const BlocksentelsrecordPerPage = 5;
  // total number of the records
  // const totalRecords = 15;
  // range of pages in paginator
  const BlocksentelspageRange = 5;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [deleteId, setdeleteId] = useState("");

  const handlePageBlocksentelsChange = (pageNumber) => {
    getBlockSentinalList(pageNumber);
    setBlocksentelscurrentPage(pageNumber);

    // setchoosepage()
  };

  const handlePageChange = (pageNumber) => {
    getcategoryNameList(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    getBlockSentinalList();
    getcategoryNameList(1);
  }, []);
  // useEffect(() => {
  //
  // }, [searchTerm]);
  const getcategoryNameList = async (page, search = "") => {
    const payload = {
      perpage: 5,
      page,
      search,
    };
    setpageLoader(true);
    const data = {
      apiUrl: apiService.get_catagary_list,
      payload,
    };
    const resp = await postMethod(data);
    setpageLoader(false);
    if (resp.status) {
      setcategoryNameList(resp.data.data);
      setTotalpages(resp.data.pages);
    }
  };

  const getBlockSentinalList = async (page, search = "") => {
    try {
      var payload = {
        perpage: 5,
        page: page,
        search,
      };
      setblockpageLoader(true);
      var data = {
        apiUrl: apiService.getBlockSentinalList,
        payload: payload,
      };
      var resp = await postMethod(data);
      setblockpageLoader(false);
      if (resp.status) {
        console.log(resp, "========resp");
        setBlocksentelscategoryNameList(resp.data.data);
        setBlocksentelstotalPage(resp.data.pages);
      }
    } catch (error) {}
  };

  const viewBlog = async (e) => {
    setFormstatus(true);
    setActivePage("edit");
    setCategory(e);
    console.log(e, categorydataref.current);
    setcatagoryNameValue(categorydataref.current.categoryname);
    setcategoryStausValue(categorydataref.current.status);
    setcategorySlug(categorydataref.current.categoryurl);
    setcategoryblogSite(categorydataref.current.categorySite);
    console.log("categorydataref===", categorydataref.current);
  };
  const setcatagaryUrl = (val) => {
    var catagaryname = val;
    setcatagoryNameValue(catagaryname);
    var slug = catagaryname
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
    setcategorySlug(slug);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        {formstatus == false ? (
          ""
        ) : (
          <div>
            {/* <div> */}
            {/* <PageTitle title="Blog Category" /> */}
            {/* </div> */}
            <div onClick={() => setFormstatus(false)}>
              <button
                style={style}
                className="btn btn-primary custom_btn text-white mb-3"
              >
                Back
              </button>
            </div>
          </div>
        )}
      </div>
      <div>
        {formstatus == true ? (
          pageactiveref.current == "add" ? (
            <div className="card blog_upload_card">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label>SiteName</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      onChange={(e) => setcategoryblogSite(e.target.value)}
                    >
                      <option value="BLF">Choose Site</option>
                      <option value="BLF">BLF</option>
                      <option value="Blocksentels">Blocksentels</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label>Category Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Category Name"
                      value={categoryNameValueref.current}
                      onChange={(e) => setcatagaryUrl(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label htmlFor="exampleInputPassword1">Catagary Url</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Category URL"
                      value={categorySlugref.current}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label>Status</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      onChange={(e) => setcategoryStausValue(e.target.value)}
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Deactive</option>
                    </select>
                  </div>
                </div>
              </div>
              <button
                disabled={
                  categoryNameValue.length === 0 ||
                  categorySlug === 0 ||
                  categoryStatusValue.length === 0
                }
                className="btn btn-primary custom_btn btn_wid"
                onClick={(e) => (
                  e.preventDefault(),
                  saveBlog(
                    categoryNameValue,
                    categorySlug,
                    categoryStatusValue,
                    setcategoryblogSiteref.current,
                    props.history,
                    setIsLoading,
                    setError,
                  ),
                  getcategoryNameList(),
                  getBlockSentinalList(),
                  setFormstatus(false)
                )}
              >
                Submit
              </button>
            </div>
          ) : (
            <div className="card blog_upload_card">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label>Category Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Category Name"
                      //value={categorydataref.current.categoryname}
                      value={categoryNameValue}
                      onChange={(e) => setcatagaryUrl(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label htmlFor="exampleInputPassword1">Catagary Url</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Category URL"
                      value={categorySlug}
                      disabled
                    />
                  </div>{" "}
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label>Status</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      onChange={(e) => setcategoryStausValue(e.target.value)}
                    >
                      <option
                        value={
                          categoryStatusValueref.current
                            ? categoryStatusValueref.current
                            : 1
                        }
                      >
                        Active
                      </option>
                      <option
                        value={
                          categoryStatusValueref.current
                            ? categoryStatusValueref.current
                            : 0
                        }
                      >
                        Deactive
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <button
                className="btn btn-primary custom_btn btn_wid"
                onClick={(e) => (
                  e.preventDefault(),
                  updateBlog(
                    categorydataref.current._id,
                    categoryNameValue,
                    categoryStatusValue,
                    categorySlug,
                    props.history,
                    setIsLoading,
                    setError,
                  ),
                  getcategoryNameList(),
                  getBlockSentinalList(),
                  setFormstatus(false)
                )}
              >
                Submit
              </button>
            </div>
          )
        ) : (
          <>
            {" "}
            <div>
              <div className="d-flex flex-wrap align-items-center justify-content-between py-4 mb-3">
                {" "}
                <Typography
                  fullWidth
                  color="inherit"
                  className={classes.blog_categories}
                  variant="body2"
                  sx={{ mt: 1 }}
                >
                  Beleaf Blog Categories
                </Typography>
                <div className="right_top">
                  <SearchBar
                    placeholder="Search by Category Name"
                    onSearch={(term) => getcategoryNameList(1, term, "Name")}
                  />
                  <div
                    onClick={() => (
                      setFormstatus(true),
                      setcatagoryNameValue(""),
                      setcategoryStausValue(""),
                      setcategorySlug(""),
                      setActivePage("add"),
                      setcategoryblogSite("")
                    )}
                    className="btn_add"
                  >
                    <span>Add</span>
                    <Icons.AddCircle />
                  </div>
                </div>
              </div>
              <div className="table_outer">
                <div className="table-responsive">
                  <table class="table m-0 table-striped">
                    <thead className="admin_thead">
                      <tr>
                        <th> S.No</th>
                        <th> Category Name </th>
                        <th> CreatedAt </th>
                        <th> Status </th>
                        <th> Edit </th>
                        <th> Delete </th>
                      </tr>
                    </thead>
                    <tbody className="admin_tbody">
                      {pageLoader === true ? (
                        Array.from({ length: 5 }).map((_, i) => (
                          <tr key={i}>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                            <td>
                              <Skeleton />
                            </td>
                          </tr>
                        ))
                      ) : categoryNameListref.current.length > 0 ? (
                        categoryNameListref.current.map((categories, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{categories.categoryname}</td>
                            <td>
                              {moment(categories.createdAt).format("lll")}
                            </td>
                            <td>
                              {categories.status === 1 ? (
                                <p className="mb-0" style={{ color: "green" }}>
                                  Active
                                </p>
                              ) : (
                                <p className="mb-0" style={{ color: "red" }}>
                                  Deactive
                                </p>
                              )}
                            </td>
                            <td
                              onClick={() => viewBlog(categories)}
                              className="cursor-pointer"
                            >
                              <i class="fa fa-edit"></i>
                            </td>

                            <td
                              className="cursor-pointer"
                              onClick={() => {
                                setdeleteId(categories._id);
                                handleOpen();
                              }}
                            >
                              {/* <i className="fa fa-external-link"></i> */}
                              <i class="fa fa-trash"></i>
                              {/* <a href="javascript:void(0)"> Edit </a> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="no-record">
                          <td colSpan={6}>
                            <div className="emptyrecordimg">
                              <img
                                src={require("../images/No-data.webp")}
                                width="100px"
                              />
                              <span className="emptyrecord">
                                No records found
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {totalPage > 1 && (
                <Pagination
                  count={totalPage}
                  page={currentPage}
                  onChange={(e, value) => handlePageChange(value)}
                  className={`${classes.blog_pagination} mt-4`}
                  color="primary"
                  shape="rounded"
                />
              )}
            </div>
            <div>
              <div className="d-flex flex-wrap justify-content-between align-items-center py-4 mb-2 mt-2">
                <Typography
                  fullWidth
                  color="inherit"
                  className={classes.blog_categories}
                  variant="body2"
                  sx={{ mt: 1 }}
                >
                  Block Sentinals Blog Categories
                </Typography>
                {/* <SearchBar
                    onSearch={(term) => getBlockSentinalList(1, term)}
                  /> */}
                <div className="right_top">
                  <SearchBar
                    placeholder="Search by Category Name"
                    onSearch={(term) => getBlockSentinalList(1, term, "Name")}
                  />
                  <div onClick={() => setFormstatus(true)} className="btn_add">
                    <span>Add</span>
                    <Icons.AddCircle />
                  </div>
                  {/* <div onClick={() => setFormstatus(true)} className="">
                        <Icons.AddCircle className="cursor-pointer mt-3" />
                      </div> */}
                </div>
              </div>
              <div className="table_outer">
                <div className="table-responsive">
                  <table class="table m-0 table-striped">
                    <thead className="admin_thead">
                      <tr>
                        <th> S.No</th>
                        <th> Category Name </th>
                        <th> CreatedAt </th>
                        <th> Status </th>
                        <th> Edit </th>
                        <th> Delete </th>
                      </tr>
                    </thead>
                    {blockpageLoader === true ? (
                      Array.from({ length: 5 }).map((_, i) => (
                        <tr key={i}>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                          <td>
                            <Skeleton />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tbody className="admin_tbody">
                        {BlocksentelscategoryNameListref.current.length > 0 ? (
                          BlocksentelscategoryNameListref.current &&
                          BlocksentelscategoryNameListref.current.map(
                            (categories, i) => {
                              console.log(categories);
                              return (
                                <tr>
                                  <td>{i + 1}</td>
                                  <td>{categories.categoryname}</td>
                                  <td>
                                    {moment(categories.createdAt).format("lll")}
                                  </td>
                                  <td>
                                    {categories.status == 1 ? (
                                      <p
                                        className="mb-0"
                                        style={{ color: "green" }}
                                      >
                                        {" "}
                                        Active{" "}
                                      </p>
                                    ) : (
                                      <p
                                        className="mb-0"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        Deactive{" "}
                                      </p>
                                    )}
                                  </td>
                                  <td
                                    onClick={() => viewBlog(categories)}
                                    className="cursor-pointer"
                                  >
                                    {/* <i className="fa fa-external-link"></i> */}
                                    <i class="fa fa-edit"></i>
                                    {/* <a href="javascript:void(0)"> Edit </a> */}
                                  </td>
                                  <td
                                    className="cursor-pointer"
                                    onClick={() => {
                                      setdeleteId(categories._id);
                                      handleOpen();
                                    }}
                                  >
                                    {/* <i className="fa fa-external-link"></i> */}
                                    <i class="fa fa-trash"></i>
                                    {/* <a href="javascript:void(0)"> Edit </a> */}
                                  </td>{" "}
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr className="no-record">
                            <td colSpan={6}>
                              <div className="emptyrecordimg">
                                <img
                                  src={require("../images/No-data.webp")}
                                  width="100px"
                                />
                                <span className="emptyrecord">
                                  No records found
                                </span>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* <Pagination
          itemClass="page-item" // add it for bootstrap 4
          linkClass="page-link" // add it for bootstrap 4
          activePage={BlocksentelscurrentPage}
          itemsCountPerPage={BlocksentelsrecordPerPage}
          totalItemsCount={BlocksentelstotalPage}
          pageRangeDisplayed={BlocksentelspageRange}
          onChange={handlePageBlocksentelsChange}
        /> */}

              {BlocksentelstotalPage > 1 && (
                <Pagination
                  count={BlocksentelstotalPage}
                  page={BlocksentelscurrentPage}
                  onChange={(e, value) => handlePageBlocksentelsChange(value)}
                  className={classes.blog_pagination}
                  color="primary"
                  shape="rounded"
                />
              )}
            </div>
          </>
        )}
      </div>
      <div>
        {/* <Button >Open modal</Button> */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styles}>
            <h5 className="logout_title">Delete Notification</h5>
            <p className="logout_content">Are your sure delete this item</p>
            <div className="logout_btn_wrapper">
              <button
                className="logout_cancel custom_btn2 text-center"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="logout_confirm custom_btn2 text-center"
                onClick={() => {
                  deleteBlog(deleteId);
                  getcategoryNameList();
                  getBlockSentinalList();
                  handleClose();
                  setFormstatus(false);
                }}
              >
                Delete
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}
